import React from 'react';
import { FilterDef, Settings } from '../../CommonTypes';
import { localization } from '../../localization';
import { FAButton, Slider } from '../coreui';
import { FiltersPaneStyled } from './FiltersPane.styles';

export interface IFiltersPaneProps {
  filters: FilterDef[];

  settings: Settings;
  values: number[];
  onFilterChanged: (newVals: number[]) => void;
}

export interface IFiltersPaneState {
}

export class FiltersPane extends React.Component<IFiltersPaneProps, IFiltersPaneState> {
  private onChange = (newVal: number, idx: number) => {
    const oldVal = this.props.values[idx];
    if (newVal !== oldVal) {
      let values = [...this.props.values];
      values[idx] = newVal;
      this.props.onFilterChanged(values);
    }
  };

  private resetAll = () => {
    this.props.onFilterChanged(this.props.filters.map(fDef => fDef.defaultValue));
  }

  public render() {
    return (
      <FiltersPaneStyled>
        <div className='FilterResetAll'>
          <span>{ localization[this.props.settings.lang].filterReset }</span>
          <FAButton icon='undo' size={40} onClick={this.resetAll} data-tip={ localization[this.props.settings.lang].tooltips.resetFilters }/>
        </div>
        { this.props.filters.map((fd, i) => (
          <React.Fragment key={i}>
            <span>{fd.displayName[this.props.settings.lang]}</span>
            <Slider value={this.props.values[i]} min={fd.minValue} max={fd.maxValue} step={fd.step}
              onChange={e => this.onChange(parseFloat(e.currentTarget.value), i)} />
            <FAButton icon={'undo'} onClick={() => this.onChange(fd.defaultValue, i)}
             data-tip={ localization[this.props.settings.lang].tooltips.resetSingleFilter(fd.displayName[this.props.settings.lang]) }/>
          </React.Fragment>
        )) }
      </FiltersPaneStyled>
    );
  }
}
